var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 11.5125L6.38379 10.05V20.8568C6.38389 20.9742 6.40711 21.0904 6.45213 21.1989C6.49715 21.3073 6.56308 21.4058 6.64617 21.4887C6.72925 21.5717 6.82786 21.6374 6.93636 21.6823C7.04487 21.7271 7.16114 21.7501 7.27854 21.75H21.6035C21.7211 21.7503 21.8375 21.7275 21.9462 21.6827C22.0549 21.638 22.1536 21.5722 22.2369 21.4893C22.3201 21.4063 22.3862 21.3077 22.4313 21.1992C22.4764 21.0907 22.4997 20.9743 22.4998 20.8568V16.875L14.6855 11.5125Z",
    fill: "#185C37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 2.25H7.27854C7.16114 2.2499 7.04487 2.27293 6.93636 2.31776C6.82786 2.3626 6.72925 2.42837 6.64617 2.51132C6.56308 2.59426 6.49715 2.69276 6.45213 2.80119C6.40711 2.90962 6.38389 3.02585 6.38379 3.14325V7.125L14.6855 12L19.0813 13.4625L22.4998 12V7.125L14.6855 2.25Z",
    fill: "#21A366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38379 7.125H14.6855V12H6.38379V7.125Z",
    fill: "#107C41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M12.3253 6.1499H6.38379V18.3374H12.3253C12.562 18.3362 12.7888 18.2418 12.9564 18.0746C13.124 17.9074 13.219 17.6809 13.2208 17.4442V7.04315C13.219 6.80641 13.124 6.57989 12.9564 6.4127C12.7888 6.2455 12.562 6.15108 12.3253 6.1499Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.837 6.63745H6.38379V18.825H11.837C12.0738 18.8238 12.3005 18.7294 12.4682 18.5622C12.6358 18.395 12.7308 18.1684 12.7325 17.9317V7.5307C12.7308 7.29396 12.6358 7.06744 12.4682 6.90024C12.3005 6.73305 12.0738 6.63863 11.837 6.63745Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.837 6.63745H6.38379V17.85H11.837C12.0738 17.8488 12.3005 17.7544 12.4682 17.5872C12.6358 17.42 12.7308 17.1934 12.7325 16.9567V7.5307C12.7308 7.29396 12.6358 7.06744 12.4682 6.90024C12.3005 6.73305 12.0738 6.63863 11.837 6.63745Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M11.3488 6.63745H6.38379V17.85H11.3488C11.5855 17.8488 11.8123 17.7544 11.9799 17.5872C12.1475 17.42 12.2425 17.1934 12.2443 16.9567V7.5307C12.2425 7.29396 12.1475 7.06744 11.9799 6.90024C11.8123 6.73305 11.5855 6.63863 11.3488 6.63745Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.3955 6.63745H11.349C11.5862 6.63725 11.8137 6.73123 11.9816 6.89872C12.1496 7.06622 12.2441 7.29353 12.2445 7.5307V16.4692C12.2441 16.7064 12.1496 16.9337 11.9816 17.1012C11.8137 17.2687 11.5862 17.3627 11.349 17.3625H2.3955C2.27804 17.3626 2.16168 17.3397 2.05309 17.2949C1.9445 17.2501 1.84581 17.1844 1.76264 17.1014C1.67948 17.0184 1.61348 16.9199 1.56841 16.8114C1.52334 16.703 1.5001 16.5867 1.5 16.4692V7.5307C1.5001 7.41324 1.52334 7.29694 1.56841 7.18847C1.61348 7.07999 1.67948 6.98146 1.76264 6.8985C1.84581 6.81555 1.9445 6.74979 2.05309 6.705C2.16168 6.66021 2.27804 6.63726 2.3955 6.63745Z",
    fill: "url(#paint0_linear_1314_22618)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2749 14.9047L6.15815 11.9917L4.43315 9.09521H5.8184L6.75965 10.95C6.84665 11.1255 6.90965 11.256 6.93815 11.343H6.9509C7.0124 11.202 7.07765 11.0662 7.1459 10.9335L8.1524 9.09821H9.4274L7.65815 11.9782L9.4724 14.907H8.11565L7.02815 12.8737C6.97766 12.7863 6.93475 12.6947 6.8999 12.6H6.8819C6.85019 12.6923 6.80791 12.7806 6.7559 12.8632L5.63615 14.9047H4.2749Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6043 2.25H14.6855V7.125H22.4998V3.14325C22.4997 3.02579 22.4765 2.90949 22.4314 2.80102C22.3863 2.69254 22.3203 2.59401 22.2372 2.51105C22.154 2.4281 22.0553 2.36234 21.9467 2.31755C21.8381 2.27276 21.7218 2.2498 21.6043 2.25Z",
    fill: "#33C481"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6855 12H22.4998V16.875H14.6855V12Z",
    fill: "#107C41"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1314_22618",
    x1: 3.3705,
    y1: 5.93545,
    x2: 10.374,
    y2: 18.0645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18884F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117E43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B6631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelFile);
export default __webpack_public_path__ + "static/media/excelFile.9d9c475291a31ae12901a50bf3c2fb46.svg";
export { ForwardRef as ReactComponent };